import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Space, Typography, Button, Modal } from "antd";
import { CrownFilled } from "@ant-design/icons";
const { Title } = Typography;

import "./style.scss";
// const styleWrapperClass = "modalUnsupportedPlan";

export default function ModalUnsupportedPlan({
  buttonTitle,
  buttonIcon,
  descriptionTitlePrefix,
  requiredPlans,
  autoShow = false,
}) {
  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(autoShow);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleConfirmation = () => {
    setIsModalOpen(false);
  };

  const planPro = (
    <>
      <CrownFilled className="fg-gold" /> Pro
    </>
  );

  const planBasic = "Básico";

  const availableIn = (
    <>
      {requiredPlans?.includes("pro") && planPro}
      {requiredPlans?.includes("basic") && " ó " + planBasic}
    </>
  );

  return (
    <>
      {!!buttonTitle && (
        <Button
          type="primary"
          icon={buttonIcon}
          size="small"
          onClick={showModal}
        >
          {buttonTitle}
        </Button>
      )}
      <Modal
        open={isModalOpen}
        onOk={handleConfirmation}
        onCancel={handleCancel}
        width={800}
        destroyOnClose={true}
        footer={null}
      >
        <Space
          style={{
            marginTop: "20px",
            marginBottom: "20px",
            width: "100%",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <Space direction="vertical">
            <Title level={3}>Disponible en el plan {availableIn}</Title>
            <Title level={5}>
              {descriptionTitlePrefix}, deberás subscribirte al plan{" "}
              {availableIn}.
            </Title>
            <Button onClick={() => navigate("/plan")}>Ver Planes</Button>
          </Space>
        </Space>
      </Modal>
    </>
  );
}
